import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import HelpButton from "../../HelpContent/HelpButton";

export default function AboutThisImport({ api, onChange, backendErrors }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  return (
    <div>
      <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker-reverse m-3 ">
        <div className="d-flex">
          <div>
            <div className="fs-4">
              About this API{" "}
              <HelpButton helpKey="api-overview-about-this-api" />
            </div>
          </div>
        </div>
        <div>
          <Form>
            <Form.Group as={Row} className="mb-3 mt-3" controlId="importTitle">
              <Form.Label column sm="4" className="fw-bold">
                Title: <HelpButton helpKey="api-overview-title" />
              </Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  value={api?.Label}
                  name="Label"
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>
            {backendErrors?.["ApiConnection.Label"] && (
              <div className="alert alert-warning">
                {backendErrors["ApiConnection.Label"]}
              </div>
            )}
            <hr className="text-secondary" />
            <Form.Group as={Row} className="mb-3" controlId="importDescription">
              <Form.Label column sm="4" className="fw-bold">
                Description <HelpButton helpKey="api-overview-description" />
              </Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  value={api?.Description}
                  name="Description"
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>
            {backendErrors?.["ApiConnection.Description"] && (
              <div className="alert alert-warning">
                {backendErrors["ApiConnection.Description"]}
              </div>
            )}
            <hr className="text-secondary" />
            <Form.Group as={Row} className="mb-3" controlId="importReference">
              <Form.Label column sm="4" className="fw-bold">
                Reference:
                <HelpButton helpKey="api-overview-reference" />
              </Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  value={api?.Reference}
                  name="Reference"
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>
            {backendErrors?.["ApiConnection.Reference"] && (
              <div className="alert alert-warning">
                {backendErrors["ApiConnection.Reference"]}
              </div>
            )}
            <hr className="text-secondary" />
            <Form.Group as={Row} className="mb-3" controlId="importStatus">
              <Form.Label column sm="4" className="fw-bold">
                Status:
                <HelpButton helpKey="api-overview-status" />
              </Form.Label>
              <Col sm="8">
                <Form.Select
                  value={api?.Status}
                  name="Status"
                  onChange={handleChange}
                >
                  <option value="draft">Draft</option>
                  <option value="production">Production</option>
                  <option value="archived">Archived</option>
                </Form.Select>
              </Col>
            </Form.Group>
          </Form>
        </div>
      </div>
    </div>
  );
}
